import styled from "styled-components";

export const ButtonContainer = styled.button`
  border: ${({ theme }) => theme.button.border.base};
  text-transform: none;
  color: ${({ theme }) => theme.button.font.primary};
  font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
  border-radius: ${({ theme }) => theme.button.radius};
  background: ${({ theme }) => theme.button.bg.primary};
  box-shadow: ${({ theme }) => theme.button.shadow};
  padding: ${({ theme }) => theme.button.padding.base};

  &:disabled {
    cursor: not-allowed;
  }

  &.button-primary {
    display: flex;
    width: fit-content;
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    border: 2px solid rgba(255, 255, 255, 0.12);
    background: #406ad0;
    font-family: "Geist", sans-serif;
    &:hover {
      background-color: rgb(0, 132, 237);
    }
    &:disabled {
      background: #6c98efff;
      cursor: not-allowed;
    }
  }
  &.button-secondary {
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    border: 1px solid rgb(213, 215, 218);
    background: rgb(255, 255, 255);
    padding: 8px 12px;
    color: rgba(10, 13, 18, 0.7);
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    box-shadow: none;
    transition: background 0.15s ease, border-color 0.15s ease;
    &:hover:not(:disabled) {
      background: rgb(246, 247, 248);
      border-color: rgb(190, 193, 198);
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &.button-outlined {
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.button.bg.primary};
    color: ${({ theme }) => theme.button.bg.primary};
    &:hover {
      background-color: transparent;
    }
  }

  &.button-options {
    background-color: ${({ theme }) => theme.input.bg.quaternary};
    color: #717184;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    border: none;
    box-shadow: none;

    &:hover {
      background-color: ${({ theme }) => theme.input.bg.quaternary};
    }

    &.selected {
      background-color: ${({ theme }) => theme.button.bg.primary};
      color: #fff;
    }
  }

  &.button-small {
    height: fit-content;
    width: fit-content;
    font-size: 14px;
    padding: ${({ theme }) => theme.button.padding.base};
  }
  &.button-medium {
    font-size: 13px;
    padding: ${({ theme }) => theme.button.padding.base};
  }
  &.button-large {
    font-size: 16px;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Placed after the size modifiers so padding/sizing wins over button-{size}. */
  &.button-link {
    background: none;
    border: none;
    box-shadow: none;
    padding: 0;
    border-radius: 0;
    color: inherit;
    font-weight: 500;
    text-decoration: underline;
    text-decoration-color: transparent;
    text-underline-position: from-font;
    transition: color 0.2s ease, text-decoration-color 0.2s ease;
    &:hover:not(:disabled) {
      text-decoration-color: currentColor;
    }
    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  &.button-dark {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 16px;
    border-radius: 8px;
    border: none;
    box-shadow: inset 0 0 0 2px ${({ theme }) => theme.auth.button.ring};
    background: ${({ theme }) => theme.auth.button.bg};
    color: ${({ theme }) => theme.button.font.primary};
    font-family: ${({ theme }) => theme.auth.fonts.body};
    font-size: 16px;
    font-weight: 500;
    transition: background 0.15s ease;
    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.auth.button.hover};
    }
    &:disabled {
      background: ${({ theme }) => theme.auth.button.disabledBg};
      color: ${({ theme }) => theme.auth.button.disabledText};
      box-shadow: none;
      cursor: not-allowed;
    }
  }

  @media (max-width: 767px) {
    &.button-options {
      white-space: normal;
    }
  }
`;

/**
 * A borderless, transparent button (tabs, icon buttons, text actions).
 * Manages its own disabled look and neutralizes the global
 * `body button[disabled]:not(.button-primary)` override (which otherwise
 * forces a white background + gray border on any disabled button).
 * The doubled `&&` boosts specificity above that global rule.
 */
export const GhostButton = styled.button`
  background: none;
  border: none;
  box-shadow: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  font-family: "Geist", sans-serif;
  transition: color 0.2s ease;

  &&:disabled,
  &&[disabled] {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    cursor: not-allowed;
  }
`;
